import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface downloadRegularKekByLabel {
  isLoading: boolean
  loadingError: string | null
  downloadRegularKek: any
}

const initialState: downloadRegularKekByLabel = {
  isLoading: true,
  loadingError: null,
  downloadRegularKek: null
}

export const downloadRegularKekByLabelSlice = createSlice({
  name: 'downloadRegularKekByLabel',
  initialState,
  reducers: {
    downloadRegularKekByLabelLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        downloadRegularKek: []
      }
    },
    downloadRegularKekByLabelUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        downloadRegularKek: action.payload
      }
    },
    downloadRegularKekByLabelErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        downloadRegularKek: null
      }
    }
  }
})

export const {
  downloadRegularKekByLabelLoadingAction,
  downloadRegularKekByLabelUpdateAction,
  downloadRegularKekByLabelErrorAction
} = downloadRegularKekByLabelSlice.actions

export default downloadRegularKekByLabelSlice.reducer
